import { NgClass } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { DataRulesService } from '../../data-rules.service';

@Component({
  selector: 'app-action-warning-block',
  templateUrl: './irreversible-action-warning-block.component.html',
  imports: [
    NgClass,
    MatTooltip
  ],
  styleUrls: ['./irreversible-action-warning-block.component.scss']
})
export class IrreversibleActionWarningBlockComponent implements OnInit {
  @Input() message: string;
  @Input() actionType: string;
  @Input() actionIndex: number;
  coloring: 'error' | 'warning';

  constructor(
    private dataRulesService: DataRulesService) {
  }

  ngOnInit(): void {
    switch (this.actionType) {
      case (this.dataRulesService.actionOpName(this.dataRulesService.actionOperators.DELETE)):
        this.coloring = 'error';
        break;
      case (this.dataRulesService.actionOpName(this.dataRulesService.actionOperators.INSERT)):
      case (this.dataRulesService.actionOpName(this.dataRulesService.actionOperators.INSERT_MULTIPLE)):
        this.coloring = 'warning';
        break;
      default:
        break;
    }
  }

}
